import React from "react"

const ASCENDING = 'ASC';
const DESCENDING = 'DESC';

const FILTERS = {
  available: { label: "Available", test: (p) => !p._drafted },
  male: { label: "Male", test: (p) => !p._drafted && p["Gender"] === "Male" },
  female: { label: "Female", test: (p) => !p._drafted && p["Gender"] === "Female" },
  all: { label: "All", test: () => true },
};

const Table = ({ headers, players: initialPlayers }) => {
  const config = { key: "Total", direction: DESCENDING };
  const [sortConfig, setSortConfig] = React.useState(config);
  const [filter, setFilter] = React.useState("available");
  const [players, setPlayers] = React.useState(initialPlayers);

  React.useEffect(() => {
    window.__setPlayers = setPlayers
    return () => { window.__setPlayers = null }
  }, []);

  const filteredItems = React.useMemo(() => {
    return players.filter(FILTERS[filter].test);
  }, [players, filter]);

  const sortedItems = React.useMemo(() => {
    let items = [...filteredItems];
    if (sortConfig !== null) {
      items.sort((a, b) => {
        let a_val = a[sortConfig.key];
        let b_val = b[sortConfig.key];
        if (!isNaN(a_val)) {
          a_val = parseInt(a_val);
          b_val = parseInt(b_val);
        }
        if (a_val < b_val) {
          return sortConfig.direction === ASCENDING ? -1 : 1;
        }
        if (a_val > b_val) {
          return sortConfig.direction === ASCENDING ? 1 : -1;
        }
        return 0;
      });
    }
    return items;
  }, [filteredItems, sortConfig]);

  const requestSort = (key) => {
    let direction = ASCENDING;
    if (sortConfig && sortConfig.key === key && sortConfig.direction === ASCENDING) {
      direction = DESCENDING;
    }
    setSortConfig({ key, direction });
  };

  const playerCount = filteredItems.length;
  const countLabel = filter === "all"
    ? `${playerCount} player${playerCount !== 1 ? "s" : ""} total`
    : `${playerCount} player${playerCount !== 1 ? "s" : ""} left`;

  return (
    <div>
      <div className="mb-2">
        {Object.entries(FILTERS).map(([key, { label }]) => (
          <button
            key={key}
            className={`btn ${filter === key ? "btn-ccs-orange" : "btn-ccs-blue"} mb-1 me-1`}
            onClick={() => setFilter(key)}
          >
            {label}
          </button>
        ))}
      </div>
      <h5 className="mb-2">{countLabel}</h5>
      {sortedItems.length > 0 && (
        <table className="table table-sm table-bordered table-striped draft-table">
          <thead className="white-text ccs-navy-bg">
            <tr>
              {headers.map((header) => (
                <th key={header} className="draft-col draft-header" onClick={() => requestSort(header)}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="ccs-navy-txt">
            {sortedItems.map((player) => (
              <tr key={player.id}>
                {headers.map((header) => (
                  <td key={header} className={player["Gender"] === "Male" ? "male" : "female"}>
                    {player[header]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default function ProductTable({ headers, players }) {
  return <Table headers={headers} players={players} />;
}
